import SendMessage from "@/components/SendMessage.vue";
import passwordInput from "@/components/Common/passwordInput.vue";
import { passwordRulesValidation } from "@/utils/vueTemplateFunction";
import { encrypt } from "@/libs/rsa";
import { restPass, restPassByEmail } from "@/service/user";
import { mapState } from "vuex";
export default {
  name: "updatePassword",
  components: {
    SendMessage,
    passwordInput
  },
  data() {
    return {
      langLo: localStorage.getItem("language") ? localStorage.getItem("language") : "",
      weakIntensity: false,
      moderateIntensity: false,
      highIntensity: false,
      showRadio: false,
      accountType: "MOBILE",
      visible: false,
      loading: false,
      rules: {
        pw: [{
          required: true,
          message: $t("c2r1q94", "密码必填"),
          trigger: "blur"
        }, {
          validator: passwordRulesValidation,
          trigger: "blur,change"
        }]
      },
      form: {
        pw: "",
        mobile: "",
        email: "",
        verificationCode: "",
        mobileAreaCode: "+86"
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  mounted() {},
  methods: {
    // redioChange
    accoutTypeChange() {
      this.$refs.sendMessage.clean();
      this.$refs.sendMessage.clearVerificationCode();
    },
    cancel() {
      this.visible = false;
      this.$emit("on-success");
      this.clean();
    },
    submit() {
      this.$refs.sendMessage.validate(async valid => {
        let valid2 = this.$refs.form.validate();
        if (valid && valid2) {
          const {
            pw,
            verificationCode: validateCode
          } = this.form;
          const password = encrypt(pw);
          let res = null;
          if (this.accountType === "MOBILE") {
            res = await restPass({
              validateCode,
              password
            });
          } else {
            res = await restPassByEmail({
              validateCode,
              password
            });
          }
          if (res.data && res.data.result == 0) {
            // 修改密码成功时使用修改语义，区别于首次设置密码提示。
            this.$Message.success({
              content: $t("ai8d7e4", "修改成功")
            });
            this.$emit("on-success");
            this.visible = false;
            this.clean();
          }
        }
        //   });
        // }
      });
    },
    clean() {
      this.$refs["form"].resetFields();
      this.form = {
        pw: "",
        mobile: "",
        email: "",
        verificationCode: "",
        mobileAreaCode: "+86"
      };
    },
    init() {
      this.form.mobile = this.user.userInfo.mobile;
      this.form.email = this.user.userInfo.email;
      if (this.form.mobile && this.form.email) {
        this.showRadio = true;
        this.accountType = "MOBILE";
      } else if (this.form.email) {
        this.showRadio = false;
        this.accountType = "EMAIL";
      } else {
        this.showRadio = false;
        this.accountType = "MOBILE";
      }
      if (this.form.mobile.indexOf("+") > -1) {
        //手机号存在区号 拆分区号和手机号
        const arr = this.form.mobile.split("-");
        this.form.mobileAreaCode = arr[0];
        this.form.mobile = arr[1];
      }
      console.log("form----", this.form);
      this.visible = true;
    }
  }
};